/** Only the false_positive_guard tool softens the false-positive penalty. */
export function logFalsePositivePenalty(hasGuard: boolean): number {
  return hasGuard ? 2 : 4;
}
/** The Log Analysis and Phishing skills soften the missed-item penalty (Lv2 -> 6, Lv3 -> 4). */
export function pickMissPenalty(level: number): number {
  return level >= 3 ? 4 : level >= 2 ? 6 : 8;
}

/**
 * Log Whisperer Lv1 hint: a night-hour (00:00-05:59 or 22:00-23:59) log event.
 * Accepts both bare "HH:MM" and date-prefixed "YYYY-MM-DD HH:MM" timestamps.
 */
export function isOddHourTimestamp(timestamp: string): boolean {
  const time = timestamp.includes(" ") ? (timestamp.split(" ")[1] ?? "") : timestamp;
  const hour = parseInt(time.split(":")[0] ?? "", 10);
  return Number.isFinite(hour) && (hour < 6 || hour >= 22);
}
